import { render, staticRenderFns } from "./kakunin-form.vue?vue&type=template&id=e4d78574&"
import script from "./kakunin-form.vue?vue&type=script&lang=js&"
export * from "./kakunin-form.vue?vue&type=script&lang=js&"
import style0 from "./kakunin-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports